var styleDataHash = "29f6dd51";
const injectCss = () => {
  var css = `.hC0Oj{--wds-input-value-font-size-medium:14px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var embed_video_default = {
  "input": "hC0Oj"
};
export {
  embed_video_default as default,
  injectCss
};
//# sourceMappingURL=embed-video-scss.js.map
